import {connect} from 'react-redux';
import ErrorMessage from './ErrorMessage';
import {hideGlobalErrorMessage} from 'common/actions/globalErrorMessage/hideGlobalErrorMessage';

const mapStateToProps = ({
                           globalErrorMessage: {showErrorMessage, message, callback},
                         }) => ({
  showErrorMessage,
  message,
  callback,
});

export default connect(
  mapStateToProps,
  {hideGlobalErrorMessage}
)(ErrorMessage);
